import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Wind(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M11.202 5.019a1 1 0 0 0-.903.276 1 1 0 1 1-1.418-1.41A3 3 0 1 1 10.998 9h-.002L11 8v1H2a1 1 0 1 1 0-2h9.004a1 1 0 0 0 .198-1.981Zm8.587 3.01a1.5 1.5 0 0 0-1.353.409 1 1 0 1 1-1.412-1.416A3.5 3.5 0 1 1 19.502 13H2a1 1 0 1 1 0-2h17.499a1.5 1.5 0 0 0 .29-2.971ZM13.998 15a3 3 0 1 1-2.117 5.115 1 1 0 1 1 1.418-1.41A1 1 0 1 0 14.004 17H2a1 1 0 1 1 0-2h11.998Z" }) }));
}
